<template>
    <div class="mt-1">
        <v-layout row>
            <v-flex xs12>
                <ctlItemImageProcess></ctlItemImageProcess>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import ctlItemImageProcess from '@/components/admin/ctlItemImageProcess'
// import ctlItemImageProcess from '@/components/admin/ctlItemImageProcess'

export default {
    components: {
        'ctlItemImageProcess' : ctlItemImageProcess
    },
    data () {
        return {
        }
    }
}
</script>
